import { render, staticRenderFns } from "./TraitementSalaire.vue?vue&type=template&id=3cab5af4&"
import script from "./TraitementSalaire.vue?vue&type=script&lang=js&"
export * from "./TraitementSalaire.vue?vue&type=script&lang=js&"
import style0 from "./TraitementSalaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports